__webpack_require__.p = "https://static-1-dev.prioracare.com/";